<template>
  <div>
    <GoogleLogin :params="params"
                 :on-success="onSuccess" :on-failure="onFailure" class=" v-btn v-btn--contained theme--light text--primary secondary">
      <img src="/googleLogo.jpg" alt="" style="padding-top: 1px; width: 24px;">
    </GoogleLogin>
    <div style="white-space: pre-line; padding-top: 5px">
      {{ $t('Google Log in') }}
    </div>
  </div>
</template>

<script>
import GoogleLogin from 'vue-google-login';
import AuthRepository from "../repositories/AuthRepository";
import Constants from "../../constants";
export default {
    name: "LoginGoogle",
    components: {
        GoogleLogin
    },
    data () {
        return {
            params: {
                client_id: Constants.LOGIN_SOCIAL.GOOGLE_ID, //passar a un fitxer
                session: false
            }
        };
    },
    methods: {
        onSuccess (googleUser) {
            this.fbGoogle(googleUser);
        },
        onFailure (err) {
            console.log(err);
        },
        fbGoogle (response) {
            AuthRepository.loginGoogle(response.xc.access_token)
                .then(response => {
                    this.$root.$emit('log-google', response);
                }).catch((err) => {
                    console.log(err);
                });
        }
    }
};
</script>


<style scoped>
</style>
